import { Injectable, Inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ConfigAssetLoaderService } from '../config/config-asset-loader.service';
import { filter, tap } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    public authService: AuthService,
    //@Inject('apiBaseUrl') private apiBaseUrl: string,
    private configService: ConfigAssetLoaderService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const config = this.configService.getConfig();
    let apiBaseUrl;
    if (config) {
      apiBaseUrl = config.apiBaseUrl;
    }

    if (
      !request ||
      !request.url ||
      !(apiBaseUrl && request.url.startsWith(apiBaseUrl))
    ) {
      return next.handle(request);
    }
    const token = this.authService.getToken();
    if (token) {
      //add sentry transaction Id for each request
      const transactionId = Math.random().toString(36).substr(2, 9);

      Sentry.setTag('transaction_id', transactionId);
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
          'Cache-Control':
            'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          Pragma: 'no-cache',
          'X-Sentry-Transaction-ID': transactionId,
        },
      });
    }
    // request = request.clone({
    //   withCredentials: true,
    // });
    //return next.handle(request);
    const startTime = performance.now();
    //console.log('call api :' + request.url);
    return next.handle(request).pipe(
      // There may be other events besides the response.
      filter((event) => event instanceof HttpResponse),
      tap((event: HttpResponse<any>) => {
        const responseTime = Math.trunc(performance.now() - startTime);
        console.log(
          'total response time for api :' + request.url + ' - ' + responseTime
        );
        //console.log("authorization header in response:"+event.headers?.get('Authorization'))
        // const authToken = event.headers?.get('Authorization')
        // if(authToken){
        //   //this.authService.refreshToken(authToken);
        // }
      })
    );
  }
}
